import SwapController from './components/SwapController';
const DTTradeController = () => {
  return <div className='pt-8 grid justify-items-center' data-sentry-component="DTTradeController" data-sentry-source-file="DTTradeController.tsx">
      <SwapController data-sentry-element="SwapController" data-sentry-source-file="DTTradeController.tsx" />
    </div>;
};
export default DTTradeController;